import { useContent } from "@/i18n";
import { Reveal } from "./Reveal";
import { Eyebrow } from "./SectionHeading";

export const Ambition = () => {
  const { t } = useContent();
  return (
    <section
      id="ambition"
      data-testid="ambition-section"
      className="relative overflow-hidden bg-navy-800 py-28 text-paper md:py-40"
    >
      {/* subtle background flourish */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-[0.35]"
        style={{
          background:
            "radial-gradient(600px 320px at 12% 20%, rgba(224,184,120,0.14), transparent 60%), radial-gradient(500px 260px at 88% 90%, rgba(224,184,120,0.10), transparent 60%)",
        }}
      />
      {/* thin gold rule */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent md:inset-x-12"
      />

      <div className="relative mx-auto grid max-w-[1440px] gap-16 px-6 md:px-12 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-5">
          <Reveal>
            <Eyebrow>{t.ambition.eyebrow}</Eyebrow>
            <h2 className="mt-6 font-serif text-3xl font-light tracking-tight text-paper sm:text-4xl lg:text-5xl">
              {t.ambition.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="mt-10">
            <div className="relative max-w-md">
              <span
                aria-hidden="true"
                className="absolute -left-2 top-0 h-full w-px bg-gradient-to-b from-gold/70 via-gold/20 to-transparent"
              />
              <p className="pl-6 text-base leading-relaxed text-ink" data-testid="ambition-body">
                {t.ambition.body}
              </p>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:col-start-7">
          <ul className="grid gap-px bg-white/5" data-testid="ambition-pillars">
            {t.ambition.pillars.map((p, i) => (
              <Reveal key={p.k} delay={0.08 * i} as="li">
                <div className="group relative flex items-baseline gap-8 bg-navy-800 px-2 py-10 transition-colors duration-500 hover:bg-navy-900/70 md:px-6 md:py-14">
                  <span
                    aria-hidden="true"
                    className="font-mono text-[10px] tracking-[0.3em] text-gold"
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h3 className="font-serif text-2xl text-paper transition-colors duration-500 group-hover:text-gold-light sm:text-3xl">
                      {p.k}
                    </h3>
                    <p className="mt-3 max-w-md text-base leading-relaxed text-ink">
                      {p.d}
                    </p>
                  </div>
                  <span
                    aria-hidden="true"
                    className="absolute bottom-0 left-0 h-px w-0 bg-gold transition-[width] duration-700 ease-out group-hover:w-1/3"
                  />
                </div>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
